<template>
	<v-container class="py-0 pt-12">
		<v-row class="py-0" justify="space-around">
			<v-col cols="3" xl="2" lg="2" md="3" sm="4"  class="pm-0">
				<v-img :src="logo" contain @click="irHome"/>
			</v-col>

			<v-col cols="6" class="pm-0">
				<v-text-field
				  dense
					v-model="search"
					outlined
					hide-details
					append-icon="search"
					label="Busqueda rápida"
					rounded
				>
				</v-text-field>
			</v-col>

			<v-col  class="pm-0">
				<div class="primary--text" v-if="getLogeado == false">
					<v-btn rounded :to="{name:'login'}" color="primary" small>
						Iniciar sesión <v-icon right>person</v-icon>
					</v-btn>
				</div>

        <div class="text-center" v-else>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                rounded  
                color="primary" 
                small 
                v-bind="attrs"
                v-on="on">
                Mi cuenta <v-icon right>person</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                v-for="tile in tiles"
                :key="tile.title"
                @click="sheet = false"
                :to="tile.path"
              >
                <v-list-item-icon>
                  <v-icon v-text="tile.icon" color="primary"></v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ tile.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
            <v-list dense>
              <v-list-item @click="salir">
                <v-list-item-icon >
                  <v-icon color="primary">logout</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Cerrar sesión</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

			</v-col>

      <v-col  class="pm-0">
        <div class="primary--text">
          <v-btn rounded :to="{name:'catarts'}" color="primary" small>
            Catálogo <v-icon right>style</v-icon>
          </v-btn>
          
        </div>
      </v-col>
		</v-row>
	</v-container>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {

    data: () => ({
      search:'',
      logo:'',
      url: '',

      tiles: [
        { icon: 'person',          title: 'Perfil'                ,path: '/miperfil'},
        { icon: 'assessment',      title: 'Datos fiscales'        ,path: '/datosfiscales'},
        { icon: 'local_shipping',  title: 'Direcciones de envío'  ,path: '/direcciones' },
        { icon: 'credit_card',     title: 'Mis Compras'           ,path: '/miscompras' },
      ],

    }),

    created(){
      this.init()
    },

    watch:{
    	search(){
    		this.buscar(this.search)
    	}
    },

    methods:{
    	...mapActions('articulos',['buscar']),

      init(){
        this.url = this.$http.options.root + 'fotos/'
        this.color()
      },

      irHome(){
      	this.$router.push({name:'home'})
      },

      color(){
        this.$http.get('config.list').then(response=>{
          var ciaws = response.body
          this.logo = this.$http.options.root + 'fotos/' + ciaws.logourl
        }, error => {
          console.log(error)
        })
      },

      salir(){
        this.$router.push({name:'login'}).catch(error=>{console.log(error)})
        this.salirLogin()
      },

    },

    computed:{
      ...mapGetters('login',['getLogeado']),
    }
  }
</script>